<script setup>
import {onMounted, ref, watch, computed} from "vue"

import VerticalModal from "@/components/base/VerticalModal.vue"
import InputAyandeh from "@/components/inputs/InputAyandeh.vue"
import Currency from "@/components/partial/Currency.vue"
import { useStore } from "vuex"

const store = useStore()

let load_object = ref(null)
let rent_by = ref('')
let price_rent = ref('')
let price_reward = ref('')
let loading_update = ref(false)


const props = defineProps({
  modelValue: { type: Boolean, default: false },
  load: { type: Object, default: null}
})

const emit = defineEmits(['update:visible', 'close', 'updated'])

const close = () => {
  emit('update:modelValue', false)
  emit('close', true)
}

const update_order = () => {
  loading_update.value = true

  const data = {
    id: load_object.value.id,
    rent_by: rent_by.value,
    price_reward: price_reward.value,
    price_rent: price_rent.value
  }

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  // eslint-disable-next-line no-undef
  axios.post('/orders/easy_update', data, config).then(({ data }) => {
    if (data?.status === 'success') {
      emit('updated', {
        load_detail_template: data.load_detail_template,
        load_list_template: data.load_list_template
      })
    }
    loading_update.value = false
    close()
  })
}

watch(
  () => store.state.order,
  (val) => {
    if (val) {
      load_object.value = val
    }
  }
)

watch(
  () => props.load,
  (val) => {
    if (val) {
      load_object.value = val
    }
  },
  { immediate: true }
)

watch(
  () => load_object.value,
  (val) => {
    price_reward = ref(val?.price_reward || '')
    price_rent = ref(val?.price_rent || '')
    rent_by = ref(val?.rent_by || '')
  },
  { immediate: true }
)

</script>

<template>
  <vertical-modal :visible="modelValue"
                  body-class="tw-p-4"
                  @close="close" header-title="ویرایش کرایه بار">
    <template #body>
      <div class="mb-3">
        <div class="form-group">
          <label>پرداخت کرایه توسط</label>
          <select class="form-control" v-model="rent_by">
            <option value="">انتخاب</option>
            <option value="ayandeh">شرکت آینده</option>
            <option value="user">مشتری</option>
          </select>
        </div>
      </div>
      <div class="mb-3">
        <input-ayandeh
          :number-format="true"
          placeholder="کرایه را وارد کنید"
          dir="ltr"
          v-model:value="price_rent"
          label="کرایه ریال"
        >
        </input-ayandeh>
      </div>
      <div class="mb-3">
        <input-ayandeh
          :number-format="true"
          placeholder="انعام را وارد کنید"
          v-model:value="price_reward"
          dir="ltr"
          label="انعام ریال"
        />
      </div>
    </template>
    <template #footer>
      <btn-ayandeh
        @click="close"
        label="انصراف"
        color="light"
        :disabled="loading_update"
      />
      <btn-ayandeh
        @click="update_order"
        label="ذخیره"
        :loading="loading_update"
      />
    </template>
  </vertical-modal>

</template>

<style scoped>

</style>
